export default __webpack_public_path__ + "static/media/home-business-services-img02.c54da62c.jpg";